import { styled } from "@mui/material";
const Container = styled("div", {
  name: "TruncateContainer",
  shouldForwardProp: (prop) => prop !== "listAlignment",
  skipSx: true,
  slot: "Root"
})(
  ({ listAlignment = "start" }) => `
  position: relative;
  display: flex;
  width: 100%;
  height: inherit;
  padding: 0px;
  overflow: hidden;
  justify-content: ${listAlignment === "start" ? "flex-start" : "flex-end"};
`
);
export {
  Container
};
//# sourceMappingURL=Container.js.map
